<template lang="">
<span>
    <b-img v-if='approveContacts' class='mr-2' src="/assets/images/closed-access.png" width="50px" height="50px" alt="Member Based"
              title="Project managers control who can join this project through either invitations or by approving requests to join."></b-img>
    <b-img v-else class='mr-2' src="/assets/images/open-access.png" width="50px" height="50px" alt="Open"
              title="Any CitSci user can join this project. They will not require approval of a project manager."></b-img>
</span>
</template>

<script>
export default {
    props: {
        approveContacts: {
            required: true,
            type: Boolean,
        }
    }
}
</script>

<style lang="">
    
</style>
